import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { space } from '@guardian/source/foundations';
import { BackToTop, Container } from '@guardian/source/react-components';
import { observerColours } from './styles';
const footer = css `
	background-color: ${observerColours.footerBackgroundColor};
`;
const contentWrapperStyles = css `
	position: relative;
	height: 60px;
`;
const footerPadding = css `
	padding-bottom: ${space[12]}px;
`;
const backToTopStyles = css `
	position: absolute;
	background-color: ${observerColours.footerBackgroundColor};
	padding: 0 ${space[2]}px;
	bottom: -20px;
	right: ${space[3]}px;

	a {
		background-color: ${observerColours.footerBackgroundColor};
		> div:hover {
			background-color: ${observerColours.footerHoverColor};
		}
	}
`;
export default function ObserverFooter() {
    return (_jsxs("footer", { css: footer, children: [_jsx(Container, { sideBorders: true, children: _jsx("div", { css: contentWrapperStyles, children: _jsx("div", { css: backToTopStyles, children: BackToTop }) }) }), _jsx(Container, { topBorder: true, cssOverrides: footerPadding })] }));
}
